import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { COS_USER_IDS } from '../cosUsers';

// The phone's bottom bar, in one place.
//
// It used to live inside the Dashboard, which is why it vanished the moment you
// opened a job — the one screen a crew spends the most time on had no way back
// except the browser. The two buttons that switch the Dashboard's own view take
// handlers; everywhere else they navigate there instead.
export default function MobileBottomNav({ active = '', onHome, onFavorites }) {
  const navigate = useNavigate();
  const { worker } = useAuth();
  const role = worker?.role || '';
  // Office leads don't clock in, so Time is not their button.
  const clocksIn = !['ProjectManager', 'Accounting', 'Executive'].includes(role);

  const go = (handler, path) => () => (handler ? handler() : navigate(path));

  return (
    <div className="bottom-nav">
      <button className={`nav-item ${active === 'home' ? 'active' : ''}`} onClick={go(onHome, '/dashboard')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 11l9-7 9 7M5 10v10h5v-6h4v6h5V10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
        <span>Home</span>
      </button>
      {clocksIn && (
        <button className={`nav-item ${active === 'time' ? 'active' : ''}`} onClick={() => navigate('/time')}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="8.5" stroke="currentColor" strokeWidth="1.5" fill="none"/><path d="M11 6.5V11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <span>Time</span>
        </button>
      )}
      <button className={`nav-item ${active === 'favorites' ? 'active' : ''}`} onClick={go(onFavorites, '/dashboard?view=favorites')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 16.9l-5.25 2.8 1-5.85L3.5 9.65l5.9-.85L12 3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>
        <span>Favorites</span>
      </button>
      <button className={`nav-item ${active === 'ask' ? 'active' : ''}`} onClick={() => navigate('/ask')}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 2C6.03 2 2 5.8 2 10.5c0 2.3.97 4.38 2.55 5.9L3.5 20l4.13-1.5C8.9 18.83 9.93 19 11 19c4.97 0 9-3.8 9-8.5S15.97 2 11 2Z" stroke="currentColor" strokeWidth="1.5" fill="none"/><path d="M8 10.5h6M8 7.5h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
        <span>Ask AI</span>
      </button>
      {COS_USER_IDS.includes(worker?.id) && (
        <button className={`nav-item ${active === 'cos' ? 'active' : ''}`} onClick={() => navigate('/cos')}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 3.2c-1.5 0-2.7 1.2-2.7 2.7 0 .95.5 1.8 1.24 2.28C8.15 8.7 7.1 10 7.1 11.6V12.8h7.8v-1.2c0-1.6-1.05-2.9-2.44-3.62.74-.48 1.24-1.33 1.24-2.28 0-1.5-1.2-2.7-2.7-2.7Z" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinejoin="round"/><path d="M5.5 15h11l1 3.9a.7.7 0 0 1-.68.86H5.18a.7.7 0 0 1-.68-.86L5.5 15Z" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinejoin="round"/></svg>
          <span>Chief of Staff</span>
        </button>
      )}
    </div>
  );
}
